<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensPedidoSelecionados"
			:headers="colunas"
			:items="itens"
			item-key="idItemPedido"
			:show-select="isEditar"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #[`header.data-table-select`]="{}">
				<v-simple-checkbox
					id="iDCheckboxItemPedido"
					:value="itensPedidoSelecionados.length === totalItens"
					:indeterminate="itensPedidoSelecionados.length > 0 && itensPedidoSelecionados.length < totalItens"
					color="primary"
					@input="onSelectAll($event)"
				></v-simple-checkbox>
			</template>
			<template #item.situacaoEntrega="{ item }">
				<icone-tooltip
					:icone="getIconeSituacaoEntrega(item)"
					:cor="getCorIconeSituacaoEntrega(item)"
					:texto="getTooltipIconeSituacaoEntrega(item)"
					tamanho="24px"
				></icone-tooltip>
			</template>
			<template #item.icone="{ item }">
				<icone-estornado
					@acao="$emit('abrir-estorno', [item], false)"
					v-if="itemEstornouTudo(item)"
				></icone-estornado>
				<icone-estornado-parcialmente
					@acao="$emit('abrir-estorno', [item], false)"
					v-if="itemEstornouParcialmente(item)"
				></icone-estornado-parcialmente>
			</template>
			<template #item.identificacao="{ item }">
				<identificacao-ampla-cota :item="item" tamanho-icone="21"></identificacao-ampla-cota>
			</template>
			<template #item.tipo="{ item }">
				<texto-tooltip
					:texto="item.tipo"
					:tamanho-maximo="textoTamanhoMaximo.tipo"
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
				></texto-tooltip>
			</template>
			<template #item.sequencia="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">{{ item.sequencia }}</span>
			</template>
			<template #item.codigo="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.codigo"
					:tamanho-maximo="textoTamanhoMaximo.codigo"
				></texto-tooltip>
			</template>
			<template #item.descricao="{ item }">
				<div class="d-flex arp_icon_and_text">
					<icone-tooltip
						v-if="item.tipoPenalidade"
						icone="mdi-alert"
						cor="grey"
						:texto="textoTooltipPenalidadeItem(item)"
						tamanho="16px"
					></icone-tooltip>
					<texto-tooltip
						:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
						:texto="item.descricao"
						:tamanho-maximo="textoTamanhoMaximo.descricao"
					></texto-tooltip>
				</div>
			</template>
			<template #item.fornecedor="{ item }" v-if="!informacoesPedido.fornecedorUnicoDaAta">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.fornecedor"
					:tamanho-maximo="textoTamanhoMaximo.fornecedor"
				></texto-tooltip>
			</template>
			<template #item.marca="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.marca"
					:tamanho-maximo="textoTamanhoMaximo.marca"
				></texto-tooltip>
			</template>
			<template #item.unidadeAquisicao="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.unidadeAquisicao"
					:tamanho-maximo="textoTamanhoMaximo.unidadeAquisicao"
				></texto-tooltip>
			</template>
			<template #item.unidadeDespesa="{ item }">
				<div v-if="itemEstornouTudo(item)">
					<v-tooltip top>
						<template #activator="{ on, attrs }">
							<span
								v-bind="attrs"
								v-on="on"
								:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
							>
								{{ item.codigoUnidadeDespesa }}
							</span>
						</template>
						<span>{{ item.codigoUnidadeDespesa }} - {{ item.descricaoUnidadeDespesa }}</span>
					</v-tooltip>
				</div>
				<div v-else>
					<div>
						<v-tooltip top v-if="!item.isEditarUnidadeDespesa">
							<template #activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on">
									{{ item.codigoUnidadeDespesa }}
								</span>
							</template>
							<span>{{ item.codigoUnidadeDespesa }} - {{ item.descricaoUnidadeDespesa }}</span>
						</v-tooltip>
						<v-icon
							v-if="devePoderEditarUnidadeDespesa(item)"
							class="material-icons ml-1"
							color="primary"
							size="15"
							v-az-auth="permissoes.pedidoUtilizacaoItemUnidadeDespesaEditar"
							@click="habilitarEdicaoUnidadeDespesa(item)"
						>
							mdi-pencil
						</v-icon>
					</div>
				</div>
				<div class="d-flex">
					<v-autocomplete
						v-if="(hasAuthority || isPedidoRascunho) && item.isEditarUnidadeDespesa && isEditar"
						v-model="item._unidadeDespesa"
						:name="`Unidade Despesa-${item.idItemPedido}`"
						class="cell-editable select"
						:items="elementosSubelementosItem"
						item-value="id"
						item-text="nome"
						dense
					>
						<template #item="{ item, attrs, on }">
							<v-list-item v-bind="attrs" v-on="on">
								<v-list-item-content>
									<texto-tooltip :tamanho-maximo="50" :texto="item.nome"></texto-tooltip>
								</v-list-item-content>
							</v-list-item>
						</template>
					</v-autocomplete>
					<v-icon
						v-if="item.isEditarUnidadeDespesa && isEditar"
						class="material-icons btn-icon__editar-item-az-money"
						color="primary"
						size="15"
						@click="editarUnidadeDespesaItem(item)"
					>
						mdi-check
					</v-icon>
				</div>
			</template>
			<template #item.saldoAta="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.saldoAta | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.saldoOrgao="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.saldoOrgao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.quantidadeSolicitada="{ item }">
				<div v-if="itemEstornouTudo(item)">
					<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
						{{ item.quantidadeSolicitadaEstornada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
					</span>
				</div>
				<div v-else>
					<div>
						<span v-if="!item.isEditarQuantidadeSolicitada">
							{{ item.quantidadeSolicitada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
						</span>
						<v-icon
							v-if="devePoderEditarQuantidadeSolicitada(item)"
							class="material-icons ml-1"
							color="primary"
							size="15"
							v-az-auth="permissoes.pedidoUtilizacaoItemQtdSolicitadaEditar"
							@click="habilitarEdicaoQuantidadeItem(item)"
							>mdi-pencil
						</v-icon>
					</div>
				</div>
				<div class="d-flex">
					<az-money
						v-if="(hasAuthority || isPedidoRascunho) && item.isEditarQuantidadeSolicitada && isEditar"
						v-model="item._quantidadeSolicitada"
						v-az-auth="permissoes.pedidoUtilizacaoItemQtdSolicitadaEditar"
						:name="`Quantidade-${item.idItemPedido}`"
						:precision="numeroCasasDecimaisQtde"
						prefix=""
						class="cell-editable"
						dense
					>
					</az-money>
					<v-icon
						v-if="item.isEditarQuantidadeSolicitada && isEditar"
						v-az-auth="permissoes.pedidoUtilizacaoItemQtdSolicitadaEditar"
						class="material-icons btn-icon__editar-item-az-money"
						color="primary"
						size="15"
						@click="editarQuantidadeItem(item)"
						>mdi-check
					</v-icon>
				</div>
			</template>
			<template #item.valorUnitario="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.valorUnitario | azCurrency(numeroCasasDecimaisValores) }}
				</span>
			</template>
			<template #item.valorTotalItemAta="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.valorTotalItemAta }}
				</span>
			</template>
			<template #[`item.acoes`]="{ item }">
				<div v-if="informacoesPedido.situacao">
					<acessar-pedido-itens-btn-acoes
						:item="item"
						:situacao="informacoesPedido.situacao"
						@estornar="$emit('abrir-estorno', [item], true)"
						@excluir="$emit('excluir', item)"
					></acessar-pedido-itens-btn-acoes>
				</div>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
	</div>
</template>
<script>
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import { mapGetters, mapState } from 'vuex'
import { actionTypes, getterTypes, mutationTypes, tipoRecebimento } from '@/core/constants'
import SalvarItemQuantidadePedidoInput from '@/core/apiclient/item-pedido/models/SalvarItemQuantidadePedidoInput'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import IconeEstornado from '@/views/components/icones/IconeEstornado.vue'
import IconeEstornadoParcialmente from '@/views/components/icones/IconeEstornadoParcialmente.vue'
import AcessarPedidoItensBtnAcoes from '@/views/pages/pedido/acessar/itens/listagem/botoes-acoes-listagem/AcessarPedidoItensBtnAcoes.vue'
import tipos from '@/core/constants/tipos'
import fluxoPedido from '@/views/mixins/bpm/fluxoPedido'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import IconeTooltip from '@/views/components/IconeTooltip.vue'
import IdentificacaoAmplaCota from '@/views/components/IdentificacaoAmplaCota.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'acessar-pedido-itens-listagem',
	components: {
		TextoTooltip,
		IconeTooltip,
		AcessarPedidoItensBtnAcoes,
		IconeEstornadoParcialmente,
		IconeEstornado,
		IdentificacaoAmplaCota,
	},
	mixins: [tabelaMixin, arpBpmMixin, fluxoPedido, validacaoPedido],
	inject: ['isEditar', 'idPedido'],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item de pedido por aqui',
			},
			paginacaoInterna: this.paginacao,
			textoTamanhoMaximo: {
				tipo: 25,
				codigo: 25,
				descricao: 25,
				marca: 25,
				unidadeAquisicao: 25,
				fornecedor: 25,
			},
			elementosSubelementosItem: [],
		}
	},
	computed: {
		itensPedidoSelecionados: {
			get() {
				return this.$store.state.itemPedido.itensSelecionados
			},
			set(item) {
				this.$store.commit(mutationTypes.ITEM_PEDIDO.SET_ITENS_SELECIONADOS, item)
			},
		},
		isSelecionouTodosItensPedido: {
			get() {
				return this.$store.state.itemPedido.isSelecionouTodosItensPedido
			},
		},
		...mapState({
			informacoesPedido: (state) => state.pedido.informacoesPedido,
			isIntegracaoRecebimentoEntregaAtivo: (state) => state.parametrosSistema.isIntegracaoRecebimentoEntregaAtivo,
		}),
		...mapGetters({
			isPedidoRascunho: getterTypes.PEDIDO.IS_PEDIDO_RASCUNHO,
		}),
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisQtde
			},
		},
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisValores
			},
		},
		colunas() {
			return this.getColunasTabela(this.informacoesPedido)
		},
	},
	async created() {
		this.limparCheckBox()
		await this.carregarInstancia(`${this.idPedido}`)
	},
	methods: {
		async editarQuantidadeItem(item) {
			if (this.podeEditarItem(item)) {
				try {
					let retorno = await this.$store.dispatch(
						actionTypes.ITEM_PEDIDO.SALVAR_ITEM_QUANTIDADE,
						new SalvarItemQuantidadePedidoInput(item.idItemPedido, item._quantidadeSolicitada),
					)

					item.quantidadeSolicitada = item._quantidadeSolicitada
					item.valorTotalItemAta = retorno.valorTotalItemAta

					this.mostrarNotificacaoSucesso('Quantidade solicitada foi adicionada com sucesso.')
					this.$emit('resetar-valor-total')
				} catch (e) {
					item._quantidadeSolicitada = item.quantidadeSolicitada
				}
			}

			item.isEditarQuantidadeSolicitada = false
		},
		async editarUnidadeDespesaItem(item) {
			if (this.podeEditarItem(item)) {
				try {
					const retorno = await this.$store.dispatch(
						actionTypes.ITEM_PEDIDO.ALTERAR_ELEMENTO_SUBELEMENTO_ITEM,
						{
							idItemPedido: item.idItemPedido,
							idElementoSubelemento: item._unidadeDespesa,
						},
					)

					item.codigoUnidadeDespesa = retorno.unidadeDespesa
					item.descricaoUnidadeDespesa = retorno.descricaoUnidadeDespesa
					item._unidadeDespesa = null
					this.elementosSubelementosItem = []

					this.mostrarNotificacaoSucessoDefault()
				} catch (e) {
					item._unidadeDespesa = null
					this.elementosSubelementosItem = []
				}
			}

			item.isEditarUnidadeDespesa = false
		},
		podeEditarItem(item) {
			return (
				(item._quantidadeSolicitada &&
					item._quantidadeSolicitada > 0 &&
					item.quantidadeSolicitada !== item._quantidadeSolicitada) ||
				(item._unidadeDespesa &&
					item._unidadeDespesa !== 0 &&
					item.codigoUnidadeDespesa !== item._unidadeDespesa)
			)
		},
		getColunasTabela(informacoesPedido) {
			const colunas = []

			if (this.isIntegracaoRecebimentoEntregaAtivo) {
				colunas.push(new TabelaColunaUtils('', 'situacaoEntrega', '1%'))
			}

			colunas.push(new TabelaColunaUtils('', 'icone', '1%'))
			colunas.push(new TabelaColunaUtils('', 'identificacao', '1%'))
			colunas.push(new TabelaColunaUtils('Tipo', 'tipo', '8%'))
			colunas.push(new TabelaColunaUtils('Seq.', 'sequencia', '3%'))
			colunas.push(new TabelaColunaUtils('Descrição', 'descricao', '15%'))

			if (informacoesPedido && !informacoesPedido.fornecedorUnicoDaAta) {
				colunas.push(new TabelaColunaUtils('Fornecedor', 'fornecedor', '10%'))
			}

			colunas.push(new TabelaColunaUtils('Marca', 'marca', '8%'))
			colunas.push(new TabelaColunaUtils('Unid. Aquis.', 'unidadeAquisicao', '5%'))
			colunas.push(new TabelaColunaUtils('Item Despesa', 'unidadeDespesa', '8%'))
			colunas.push(new TabelaColunaUtils('Saldo Ata', 'saldoAta', '8%'))
			colunas.push(new TabelaColunaUtils('Saldo Órgão', 'saldoOrgao', '8%'))
			colunas.push(new TabelaColunaUtils('Qtde. Solicitada', 'quantidadeSolicitada', '8%'))
			colunas.push(new TabelaColunaUtils('Valor Unitário', 'valorUnitario', '8%'))
			colunas.push(new TabelaColunaUtils('Valor Total', 'valorTotalItemAta', '15%'))
			if (this.isEditar && (this.hasAuthority || this.isPedidoRascunho))
				colunas.push(new TabelaColunaUtils('Ações', 'acoes', '5%'))

			return colunas
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
		habilitarEdicaoQuantidadeItem(item) {
			item.isEditarQuantidadeSolicitada = true
		},
		habilitarEdicaoUnidadeDespesa(item) {
			item.isEditarUnidadeDespesa = true
			this.buscarElementosSubelementosItem(item.idItemPedido)
		},
		async buscarElementosSubelementosItem(idItemPedido) {
			const { itens } = await this.$store.dispatch(
				actionTypes.ITEM_PEDIDO.BUSCAR_ELEMENTOS_SUBELEMENTOS_ITEM,
				idItemPedido,
			)
			this.elementosSubelementosItem = itens.map((item) => ({
				id: item.id,
				nome: `${item.codigo} - ${item.descricao}`,
			}))
		},
		itemEstornouTudo(item) {
			return item.tipoEstorno === tipos.TIPO_ESTORNO_ITEM_PEDIDO.ESTORNO_COMPLETO.value
		},
		itemEstornouParcialmente(item) {
			return item.tipoEstorno === tipos.TIPO_ESTORNO_ITEM_PEDIDO.ESTORNO_PARCIAL.value
		},
		onSelectAll(value) {
			if (value && !this.isSelecionouTodosItensPedido) {
				this.$store.commit(mutationTypes.ITEM_PEDIDO.SET_TODOS_ITENS_SELECIONADOS, true)
				this.itensPedidoSelecionados = this.itens
			} else {
				this.limparCheckBox()
			}
		},
		limparCheckBox() {
			this.$store.commit(mutationTypes.ITEM_PEDIDO.SET_TODOS_ITENS_SELECIONADOS, false)
			this.itensPedidoSelecionados = []
		},
		devePoderEditarQuantidadeSolicitada(item) {
			return (
				(this.hasAuthority || this.isPedidoRascunho) &&
				!item.isEditarQuantidadeSolicitada &&
				this.isEditar &&
				!this.estaEmSituacaoOndeItemNaoPodeSerAlterado(this.informacoesPedido)
			)
		},
		devePoderEditarUnidadeDespesa(item) {
			return (
				(this.hasAuthority || this.isPedidoRascunho) &&
				!item.isEditarUnidadeDespesa &&
				this.isEditar &&
				!this.estaEmSituacaoOndeItemNaoPodeSerAlterado(this.informacoesPedido)
			)
		},
		textoTooltipPenalidadeItem(item) {
			return `Sanção ${item.tipoPenalidade}`
		},
		getIconeSituacaoEntrega(item) {
			switch (item.situacaoEntrega) {
				case 'AGUARDANDO_RECEBIMENTO':
					return 'mdi-clock-outline'
				case 'RECEBIMENTO_PARCIAL':
					return 'mdi-clock-outline'
				case 'RECEBIMENTO_FINALIZADO':
					return 'mdi-check-circle-outline'
				case 'ESTORNO':
					return 'mdi-alert-circle-check-outline'
				default:
					return null
			}
		},
		getCorIconeSituacaoEntrega(item) {
			switch (item.situacaoEntrega) {
				case 'AGUARDANDO_RECEBIMENTO':
					return 'orange'
				case 'RECEBIMENTO_PARCIAL':
					return 'orange'
				case 'RECEBIMENTO_FINALIZADO':
					return 'green'
				case 'ESTORNO':
					return 'red'
				default:
					return null
			}
		},
		getTooltipIconeSituacaoEntrega(item) {
			if (item.situacaoEntrega) {
				return tipoRecebimento[item.situacaoEntrega].text
			}

			return null
		},
	},
}
</script>
<style lang="stylus" scoped>
>>> .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	padding: 0 0.4rem !important
}

.cell-editable.select {
	width: 140px
}
</style>
